module.exports = "../../../../platform/assets/pageMainIcon/industry_yewuchulilei5.svg";